import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledPDFViewer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & .pdf-controls-wrapper {
    padding: 8px 0;
  }

  & .pdf-page-controls {
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  & .pdf-page-indicator {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }

  & .pdf-document-container {
    border: 1px solid ${theme.colors.grey_5};
    width: 100%;
    justify-content: center;
    display: flex;
    height: calc(100vh - 380px);
    overflow-y: auto;
  }
`;

export const StyledCertificateModal = styled.div`
  display: flex;
  flex-direction: column;
`;
